import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useRequestIndeedFlexOtpChallengeMutation } from 'queries/admin/indeedFlex/useRequestIndeedFlexOtpChallengeMutation'
import { useSubmitIndeedFlexOtpMutation } from 'queries/admin/indeedFlex/useSubmitIndeedFlexOtpMutation'

type IndeedFlexOtpContextState = {
  state: {
    requestState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
      data: ReturnType<typeof useRequestIndeedFlexOtpChallengeMutation>['data']
    }
    submitState: {
      isPending: boolean
      isSuccess: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    requestChallenge: ReturnType<
      typeof useRequestIndeedFlexOtpChallengeMutation
    >['mutate']
    submitCode: ReturnType<typeof useSubmitIndeedFlexOtpMutation>['mutate']
  }
}

const [Context, useIndeedFlexOtpContextValue] =
  createContext<IndeedFlexOtpContextState>({
    name: 'IndeedFlexOtpContext',
  })

export const IndeedFlexOtpProvider = ({ children }: PropsWithChildren) => {
  const requestChallengeMutation = useRequestIndeedFlexOtpChallengeMutation()
  const submitCodeMutation = useSubmitIndeedFlexOtpMutation()

  const value: IndeedFlexOtpContextState = {
    state: {
      requestState: {
        isPending: requestChallengeMutation.isPending,
        isError: requestChallengeMutation.isError,
        errorMessage: parseErrorMessage(requestChallengeMutation.error),
        data: requestChallengeMutation.data,
      },
      submitState: {
        isPending: submitCodeMutation.isPending,
        isSuccess: submitCodeMutation.isSuccess,
        isError: submitCodeMutation.isError,
        errorMessage: parseErrorMessage(submitCodeMutation.error),
      },
    },
    actions: {
      requestChallenge: requestChallengeMutation.mutate,
      submitCode: submitCodeMutation.mutate,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useIndeedFlexOtpContextValue }
